import { ApplicationInsights } from '../../../application-insights';
export const checkForApplicationInsights = options => {
  // This is for worker threads where the environment is completely detached from the real environment
  // in that case we need to try at least initialize from the options that pino sends us when we pass
  // the Node.js version of our application insights transport
  if (!ApplicationInsights.isInitialized() && options) {
    // Set this just in case
    global.oriAppInsightsSettings = options;
    ApplicationInsights.initialize(options);
  }
  if (!ApplicationInsights.isInitialized()) {
    throw new Error('Application Insights is not initialized, could not use logger');
  }
};
//# sourceMappingURL=checkForApplicationInsights.js.map